import { AppHeader } from 'containers';
import { useQuery } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import { saveSystem } from 'reducers/system';
import { privateRoute } from 'routes';
import { systemService, walletService } from 'services';
import { useWindowSize } from 'hooks';
import { profileSelector } from 'reducers/profile';
import { Button, Typography } from '@mui/material';
import useNotification from 'hooks/useNotification';

const PrivateLayout = () => {
  useNotification();

  const dispatch = useDispatch();
  const { isMobile } = useWindowSize();
  const { isLoggedIn } = useSelector(profileSelector);

  useQuery('systemService.fetchSystem', () => systemService.fetchConfig(), {
    onSuccess: (data) => {
      dispatch(saveSystem(data));
    },
  });

  return (
    <div>
      <main style={{ marginLeft: isMobile ? '0' : '280px' }}>
        <AppHeader />
        <div className='sm:px-6 px-4 py-4 pt-8'>
          {!isLoggedIn ? (
            <div className='flex flex-col items-center gap-3 py-10'>
              <Button variant='outlined' onClick={() => walletService.connectWallet()}>
                Connect Wallet
              </Button>
              <Typography>Please connect wallet to continue as an Administrator</Typography>
            </div>
          ) : (
            <Routes>
              {Object.values(privateRoute).map(({ path, element }) => (
                <Route key={path} path={path} element={element} />
              ))}
              <Route path='/*' element={<Navigate to={privateRoute.home.path} />} />
            </Routes>
          )}
        </div>
      </main>
    </div>
  );
};

export default PrivateLayout;
